//export const BASE_URL_TEST=process.env.REACT_APP_BASE_URL
export const BASE_URL_TEST='https://api.sthanick.com'
